module.exports = __webpack_public_path__ + "funding1-b2b9a512186a8f3482948f518e3cb60f.png";